import React, { useState, useEffect } from 'react';
import { getInnerWindowSize, getWindowOrThrow } from 'app/utils/env';
import { SetViewportSize } from 'app/components/layout/ViewportContext';

const SetWindowViewport: React.FC<{
  children: React.ReactNode,
  onResize?: () => void,
}> = ({
  children,
  onResize,
}) => {
  const [size, setSize] = useState(getInnerWindowSize());
  useEffect(() => {
    const checkSize = () => {
      const newSize = getInnerWindowSize();
      setSize(prevSize => (
        (prevSize.width !== newSize.width || prevSize.height !== newSize.height) ?
          newSize :
          prevSize
      ));

      onResize?.();
    };

    getWindowOrThrow().addEventListener('resize', checkSize);
    return () => {
      getWindowOrThrow().removeEventListener('resize', checkSize);
    };
  }, [onResize]);

  return (
    <SetViewportSize size={size}>
      {children}
    </SetViewportSize>
  );
};

export default SetWindowViewport;
